import * as React from 'react'

import { type Item } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import {
  ProjectTimeRecord,
  SubProject,
} from 'modules/project_management/hooks/projectTimeRecord/useGetProjectTimeRecords'

import { IProjectValues, IShiftWithProjectValuesHandler } from './types'

interface AddSubprojectTimeRecordProps {
  shiftWithProjectTimeRecord: ProjectTimeRecord | null
  shiftWithProjectValues: IProjectValues
  shiftWithProjectValuesHandler: ({
    shiftId,
    projectWorkerId,
    subprojectId,
  }: IShiftWithProjectValuesHandler) => void
  subprojects: SubProject[]
}

const AssignSubprojectToShiftForm = ({
  shiftWithProjectTimeRecord,
  shiftWithProjectValues,
  shiftWithProjectValuesHandler,
  subprojects,
}: AddSubprojectTimeRecordProps) => {
  const [name, setName] = React.useState<string>(shiftWithProjectTimeRecord?.subproject?.name || '')

  const onSelectSubproject = ({ label: name, value }: Item) => {
    setName(name)

    shiftWithProjectValuesHandler({
      shiftId: shiftWithProjectValues.shiftId,
      subprojectId: String(value),
    })
  }

  const onSelectEmpty = () => {
    setName('')

    shiftWithProjectValuesHandler({
      shiftId: shiftWithProjectValues.shiftId,
      subprojectId: undefined,
    })
  }

  const subprojectListItem: Item[] = subprojects.map((subproject) => ({
    label: subproject.name,
    value: subproject.id!,
  }))

  return (
    <DropdownSearchBar
      name={name || i18n.t('common.select')}
      label={i18n.t('clock_in.projects.modal.subproject_field_title')}
      onSelectEmpty={onSelectEmpty}
      onSelect={onSelectSubproject}
      data={subprojectListItem}
      labelNotFound={i18n.t('common.projects_not_found')}
      searchLabel={i18n.t('common.search')}
      sortLabel={i18n.t('common.name')}
      selectLabel={i18n.t('common.select')}
    />
  )
}

export default AssignSubprojectToShiftForm
